module.exports = __webpack_public_path__ + "img/H3.eb9ee23d.png";